import React, {
    Fragment,
    useEffect,
    useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
} from 'reactstrap'
import {
    Link,
    useNavigate,
} from 'react-router-dom'
import Flex from '../common/Flex'
import withAuthSplit, { WithAuthSplitInjectedProps } from './withAuthSplit'
import OverlayLoader from '../shared/overlay-loader'
import { sendPasswordResetEmail } from '../shared/auth'

const bgImg = '../images/loginImage.jpg'

interface ForgottenPasswordProps extends WithAuthSplitInjectedProps {
    boxTitle?: string
}

/**
 * Forgotten-password page — sends a password-reset e-mail via Firebase Auth.
 */
const ForgottenPassword = ({
    setBgProps,
    boxTitle,
}: ForgottenPasswordProps) => {
    const { t } = useTranslation()

    const [email, setEmail] = useState<string>(
        (new URLSearchParams(window.location.search)).get('email') || '',
    )
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const navigate = useNavigate()

    useEffect(
        () => setBgProps({ image: bgImg, position: '50% 20%' }),
        [setBgProps],
    )

    const submitForm = (event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault()
        setIsLoading(true)

        sendPasswordResetEmail(email)
            .then(() => {
                setEmail('')
                navigate('/login')
                return (window as Window & typeof globalThis & { swalert?: (msg: string, type: string) => unknown }).swalert?.(t('auth.forgottenPasswordSend'), 'success')
            })
            .catch(err => (window as Window & typeof globalThis & { swalert?: (msg: string, type: string) => unknown }).swalert?.(t((err as { code: string }).code), 'error'))
            .finally(() => setIsLoading(false))
    }

    return (
        <Fragment>
            <Flex align='center' justify='between'>
                <h3 className="d-flex flex-row align-items-center">
                    <Link to="/login" className="d-flex align-items-center text-dark">
                        <i className="fas fa-arrow-left mr-2" />
                    </Link>
                    {boxTitle ? t(boxTitle) : t('auth.forgottenPassword')}
                </h3>
            </Flex>

            <div className="auth-wrapper auth-v2">

                <Row className="auth-inner m-0">
                    <Col className="d-flex align-items-center auth-bg">
                        <Col className="px-xl-2 mx-auto">
                            <Form
                                className="auth-login-form mt-3"
                                onSubmit={submitForm}
                            >
                                <FormGroup>
                                    <Label
                                        className="form-label"
                                        for="login-email"
                                    >
                                        {t('auth.email')}
                                    </Label>
                                    <Input
                                        autoFocus
                                        type="email"
                                        value={email}
                                        id="login-email"
                                        name="login-email"
                                        placeholder="jan.novak@gmail.com"
                                        onChange={e => setEmail(e.target.value)}
                                        required
                                    />
                                </FormGroup>

                                {isLoading && (
                                    <OverlayLoader />
                                )}

                                <Button
                                    type="submit"
                                    color="primary"
                                    block
                                >
                                    {t('auth.submit')}
                                </Button>
                            </Form>
                        </Col>
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}

export default withAuthSplit(ForgottenPassword)
